export const saveRegisterInput = (username, email, password, signUpResult) => {
  return {
    type : 'REGISTER_INPUT',
    username,
    email,
    password, 
    signUpResult
  }
};
